/**
 * FAB Component - Component Definition
 * ====================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { FabController } from './controller';
import { FAB_TEMPLATE } from './template';
import {
  INTENT_EMPHASIS,
  INTENT_RING,
  SIZES,
  BASE_CLASSES,
  ICONS,
  SPINNER_SVG,
  DEFAULTS,
  FabIntent,
  FabEmphasis,
  FabSize,
  FabType,
  FabIconType
} from './constants';

export interface IFabComponentBindings {
  icon?: FabIconType;
  intent?: FabIntent;
  emphasis?: FabEmphasis;
  size?: FabSize;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  loading?: boolean;
  type?: FabType;
  onClick?: (args: { $event: Event }) => void;
}

export const fabComponentDefinition: IComponentOptions = {
  template: FAB_TEMPLATE,
  controller: FabController,
  transclude: true,
  bindings: {
    icon: '@',
    intent: '@',
    emphasis: '@',
    size: '@',
    label: '@',
    ariaLabel: '@',
    disabled: '<',
    loading: '<',
    type: '@',
    onClick: '&?'
  }
};

export const MODULE_NAME = 'ec.fab';

const fabModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecFab', fabComponentDefinition);

export {
  FabController,
  FAB_TEMPLATE,
  INTENT_EMPHASIS,
  INTENT_RING,
  SIZES,
  BASE_CLASSES,
  ICONS,
  SPINNER_SVG,
  DEFAULTS
};

export type {
  FabIntent,
  FabEmphasis,
  FabSize,
  FabType,
  FabIconType
} from './constants';

export default fabModule;
